import { copyToClipboard } from '@helpers';

export default {
  name: 'JobLinksViewer',

  props: {
    links: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    copyLink(link) {
      copyToClipboard(link, 'linksLayout');
    },
  },
};
